export const SAMPLE_MATRIX: string[][] = [
  ['0', '0', '2', '4', '8'],
  ['2', '6', '4', '1', '0'],
  ['4', '7', '8', '5', '2'],
  ['4', '5', '5', '7', '9'],
  ['4', '7', '4', '4', '1'],
];

export const CARTESIAN_MATRIX: string[][] = [
  ['A1', 'B1', 'C1', 'D1', 'E1'],
  ['A2', 'B2', 'C2', 'D2', 'E2'],
  ['A3', 'B3', 'C3', 'D3', 'E3'],
  ['A4', 'B4', 'C4', 'D4', 'E4'],
  ['A5', 'B5', 'C5', 'D5', 'E5'],
];

export const getPrizeSequence = (
  baseMatrix: string[][],
  selectedValues: string[],
): string[] => {
  const result: string[] = [];

  selectedValues.forEach((value) => {
    for (let rowIndex = 0; rowIndex < CARTESIAN_MATRIX.length; rowIndex++) {
      const cellIndex = CARTESIAN_MATRIX[rowIndex].indexOf(value);
      if (cellIndex !== -1) {
        result.push(baseMatrix[rowIndex][cellIndex]);
        break;
      }
    }
  });

  return result;
};
